import React from 'react';

import ClockIcon from '@atlaskit/icon/core/clock';

const RelatedLinksActionIcon = () => (
	<ClockIcon color="currentColor" spacing="spacious" label="View related links..." />
);

export default RelatedLinksActionIcon;
